import React from 'react'
import PropTypes from 'prop-types';
import {DemandValidation, DemandValidationKeys} from "constants/DemandValidation";
import PreparingAdditionalInfo from "../../../part1/panels/additionalInfo/PreparingAdditionalInfo";


function Index(
    {
        expanded
    }) {
    return expanded &&
        <PreparingAdditionalInfo sectionId={DemandValidation.FINISH_ADDITIONAL_INFO} formId={DemandValidationKeys.FINISH_ADDITIONAL_INFO}/>
}

Index.propTypes = {
    expanded: PropTypes.bool,
}

export default Index;